var render = function (_h,_vm) {var _c=_vm._c;return _c('router-link',{staticClass:"link primary new-employee-button",attrs:{"to":"/employees/new"}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}}),_vm._v(" "+_vm._s(_vm.parent.$t('Employee.new'))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }